<div class="modal-column">
    <h5>Notifications</h5>
    <a href="#" class="dropdown-link" (click)="$event.preventDefault(); notificationMark(notification._id)" *ngFor="let notification of notifications">
        <div class="notification-dot" [class.seen]="notification.seenAt"></div>
        <div class="dropdown-link-text">{{ notification.text }}</div>
    </a>
    <a href="#" class="dropdown-link" (click)="$event.preventDefault()" *ngIf="notifications.length == 0">
        <div class="dropdown-link-text">No notifications yet</div>
    </a>

    <a [routerLink]="['/', {outlets: { modal: null } } ]" class="icon close-popup">
        <i class="fal fa-times"></i>
    </a>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/notifications/notifications-modal.template.html